define('presentation/settings/integrations/viewModels/removeIntegrationModalViewModel',[
    'common/promises/promiseFactory',
], function() {
    return function(integration) {
        const self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        self.integration = integration;

        self.activate = () => {
            return _promiseFactory.wait();
        };
    };
});
